<template>
  <KPaginatedAutocomplete :paginator="autocomplete" v-bind="$attrs" v-on="$listeners" ref="autocomplete"/>
</template>

<script>
import { autocomplete } from '@/api/endpoints/client.js';
import KPaginatedAutocomplete from '@/components/crud/fields/KPaginatedAutocomplete.vue';

export default {
  name: 'ClientAutocomplete',
  components: { KPaginatedAutocomplete },
  methods: {
    autocomplete(page, perPage, search, sortBy, descending, params) {
      return autocomplete(page, perPage, search, sortBy, descending, params);
    },
  },
};
</script>
